import {
  getStaticPathsGenerator,
  getStaticPropsGenerator,
} from '@cinch-nx/landing-feature-articles'

const path = 'articles/guides/electric-cars'
const resolveRelations = 'ArticleTemplate.relatedJargon'
const shouldUndashifyAndCapitalise = true

const passedBreadCrumbs = [
  { text: 'Home', url: '/' },
  { text: 'Announcements', url: '/announcements/cinch-news' },
  { text: 'Cinch News', url: '/announcements/cinch-news' },
]

export const getStaticProps = getStaticPropsGenerator({
  path,
  resolveRelations,
  passedBreadCrumbs,
  shouldUndashifyAndCapitalise,
})

export const getStaticPaths = getStaticPathsGenerator(path)

export { ArticlesFeature as default } from '@cinch-nx/landing-feature-articles'
